import React from "react";
import {  Nav } from "react-bootstrap";
import './Topbar.css'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import WhatsappOutlinedIcon from '@mui/icons-material/WhatsappOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import Tooltip from '@mui/material/Tooltip';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';


function Topbar() {
    return(
        <>
        <div className="bg-gradient topbarr" variant="light">
          <div className="container">
            <div className="d-flex">
              <div className="col-5 text-center">
              <div className="bold p-3" href="#home">
                    <PhoneIcon className="iconSize"/> <small>Mobile : +88 01986 76 97 65</small>
                </div>
              </div>
              <div className="col-4 text-center">
                 <div className="bold p-3" href="#features"><EmailIcon className="iconSize"/> Email : <small>shwapnonirman@gmail.com</small></div>
              </div>
              <div className="col-3 d-flex">
                <Nav.Link className="tomatto facebook pt-3" href="https://www.facebook.com/shwapnonirman"><span>
                    <Tooltip title="Facebook"><FacebookOutlinedIcon /></Tooltip></span>
                </Nav.Link>
                <Nav.Link className="tomatto pt-3" href="https://wa.me/message/3MLKG5PI34APN1"><span>
                    <Tooltip title="Whatsapp"><WhatsappOutlinedIcon /></Tooltip></span>
                </Nav.Link>
                <Nav.Link className="tomatto pt-3" href="https://www.instagram.com/shwapnonirman/"><span>
                    <Tooltip title="Instagram"><InstagramIcon /></Tooltip></span>
                </Nav.Link>
              </div>
            </div>
          </div>
        </div>
        {/* <Navbar className="topbar bg-gradient" >
          <Container>
          <Nav className="">
             <Tooltip title="Mobile"><Nav.Link className="bold" href="#home"><span>
                  <PhoneIcon className="iconSize"/></span> <small>Mobile : +88 01986 76 97 65</small>
                  </Nav.Link></Tooltip>
            <Tooltip title="Gmail"><Nav.Link className="bold" href="#features"><span><EmailIcon className="iconSize"/> </span> Email : <small>shwapnonirman@gmail.com</small></Nav.Link>
                  </Tooltip>
            </Nav>
            <Nav className="col-4">
            
            <Nav.Link className="tomatto facebook" href="https://www.facebook.com/shwapnonirman"><span>
                    <Tooltip title="Facebook"><FacebookOutlinedIcon /></Tooltip></span>
                </Nav.Link>
                <Nav.Link className="tomatto" href="https://wa.me/message/3MLKG5PI34APN1"><span>
                    <Tooltip title="Whatsapp"><WhatsappOutlinedIcon /></Tooltip></span>
                </Nav.Link>
                <Nav.Link className="tomatto" href="https://www.instagram.com/shwapnonirman/"><span>
                    <Tooltip title="Instagram"><InstagramIcon /></Tooltip></span>
                </Nav.Link>
            
            </Nav>
          </Container>
        </Navbar> */}
      </>)
        
    
}
export default Topbar;
